

export enum SubscriptionLevel {

    BRONZE = 10, SILVER = 20, GOLD = 30

}
